<template>
	<div class="text-field-container">
		<EditableTextField
			ref="name"
			isEditOnClick
			:text="textLocal"
			@blur="saveAndBlur"
			@onSave="saveAndBlur"
			placeholder="Enter Name"
			:isEditing.sync="isEditing"
			@keydown.enter="saveAndBlur"
			@keydown.escape="saveAndBlur"
			:disabled="!hasEditPermissions"
			class="editable-text-field text-overflow-ellipsis"
		>
			<template v-slot:append>
				<AppDropdownMenu right bottom absolute v-bind="$attrs" min-width="200" v-on="$listeners" :nudge-bottom="15" :items="menuItems">
					<template #activator="{ value }">
						<AnemicButton
							fab
							icon
							width="24"
							height="26"
							tabindex="-1"
							class="flex-centerize"
							:style="'background: transparent !important'"
						>
							<v-icon>{{ value ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
						</AnemicButton>
					</template>
				</AppDropdownMenu>
			</template>
		</EditableTextField>
	</div>
</template>

<script>
import EditableTextField from '@/components/common/EditableTextField';
export default {
	name: 'ProjectNameEditableTextField',
	components: {
		EditableTextField,
	},
	props: {
		text: { type: String },
		hasChevron: { type: Boolean },
		placeholder: { type: String },
		hasEditPermissions: { type: Boolean },
		isEditOnClick: { type: Boolean, default: false },
	},
	methods: {
		onDelete() {
			this.$refs.name.onDelete();
		},
		saveAndBlur(newText) {
			this.$refs.name.blur();
			this.saveName(newText);
		},

		saveName(newText) {
			this.$emit('onSave', newText);
			this.isEditing = false;
		},
		onClick() {
			if (this.isEditOnClick) {
				this.isEditing = true;
			}
		},
	},
	watch: {
		text: {
			handler(newV) {
				if (newV) {
					this.textLocal = newV;
				}
			},
			immediate: true,
			deep: true,
		},
	},
	data() {
		return {
			isEditing: false,
			textLocal: '',
			menuItems: [
				{
					id: 'rename',
					text: 'Rename',
					onClick: this.onClick,
				},
				{
					id: 'delete',
					text: 'Delete',
					onClick: this.onDelete,
				},
			],
		};
	},
};
</script>

<style scoped lang="scss">
.editable-text-field {
	&::v-deep {
		&.v-text-field {
			> .v-input__control > .v-input__slot {
				&:before {
					border-color: rgba(0, 0, 0, 0.42);
					border: none;
				}
				&:hover {
					border-bottom: 1px dashed grey !important;
				}

				&:after {
					border-width: 1px !important;
				}
			}

			&.v-input--is-disabled,
			&.v-input--is-disabled input {
				color: #3e495a !important;
				opacity: 1 !important;
			}
		}
	}
}
.text-field-container {
	width: 200px;
}
</style>
